import Posture from './Posture';

export default Posture;
